import React, { Tooltip } from '@mui/material';
import { Control, TextFieldElement } from 'react-hook-form-mui';
import ListItem from '@mui/material/ListItem';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ProductsForm } from '../../../types/editableOfferCard.formValues';
import ProductSearchBar from './ProductSearchBar';
import { ProductSearch } from '../../../../../services/api/dto/search.dto';

const styleIndex = { width: '2%' };
const inputStyleProduct = { width: '40%' };
const inputStyleQty = { width: '15%', pl: 1 };
const inputStylePercent = { width: '17%', pl: 1 };
const inputStylePrice = { width: '22%', pl: 1 };
const styleButton = { width: '4%' };
type ProductItemProps = {
    onClickRemoveItem: () => void;
    index: number;
    disabledInputs: boolean;
    control: Control<ProductsForm>;
    setProduct: (index: number, product: ProductSearch) => void;
};

export function ProductItem({
    onClickRemoveItem,
    index,
    disabledInputs,
    control,
    setProduct,
}: ProductItemProps) {
    const namePrefix = `products.${index}`;
    return (
        <ListItem
            sx={{
                width: '100%',
                px: 0,
                py: 1,
                ':hover': {
                    backgroundColor: '#edf6fc',
                },
            }}>
            <Typography variant="body2" color="grey.400" sx={styleIndex}>
                {index + 1}
            </Typography>
            <Box sx={inputStyleProduct}>
                <ProductSearchBar
                    index={index}
                    name={`products.${index}.name`}
                    control={control}
                    disabled={disabledInputs}
                    setProduct={setProduct}
                />
            </Box>
            <TextFieldElement
                required
                type="number"
                name={`${namePrefix}.quantity`}
                size="small"
                variant="standard"
                disabled={disabledInputs}
                parseError={() => ''}
                validation={{ min: 1 }}
                sx={inputStyleQty}
                InputProps={{
                    inputProps: {
                        style: { textAlign: 'right' },
                    },
                }}
            />
            <TextFieldElement
                required
                type="number"
                name={`${namePrefix}.discount_percent`}
                size="small"
                variant="standard"
                disabled={disabledInputs}
                parseError={() => ''}
                validation={{ min: 0, max: 100 }}
                sx={{
                    ...inputStylePercent,
                    '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
                        display: 'none',
                    },
                }}
                InputProps={{
                    inputProps: {
                        style: { textAlign: 'right' },
                    },
                    startAdornment: (
                        <InputAdornment position="start" sx={{ marginBottom: '2px' }}>
                            %
                        </InputAdornment>
                    ),
                }}
            />
            <Tooltip
                title="Precio unitario del producto, sin el descuento aplicado"
                enterDelay={2000}>
                <Box sx={inputStylePrice}>
                    <TextFieldElement
                        required
                        type="number"
                        name={`${namePrefix}.unit_price`}
                        size="small"
                        variant="standard"
                        disabled={disabledInputs}
                        parseError={() => ''}
                        validation={{ min: 0 }}
                        sx={{
                            '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button':
                                {
                                    display: 'none',
                                },
                        }}
                        InputProps={{
                            inputProps: {
                                style: { textAlign: 'right' },
                            },
                            startAdornment: (
                                <InputAdornment position="start" sx={{ marginBottom: '2px' }}>
                                    $
                                </InputAdornment>
                            ),
                        }}
                    />
                </Box>
            </Tooltip>
            {!disabledInputs && (
                <Box sx={{ ...styleButton, display: 'flex', alignItems: 'center' }}>
                    <Tooltip title="Eliminar item" enterDelay={2000}>
                        <IconButton size="small" onClick={onClickRemoveItem}>
                            <DeleteIcon sx={{ width: '18px', height: '18px' }} />
                        </IconButton>
                    </Tooltip>
                </Box>
            )}
        </ListItem>
    );
}
